import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = React.forwardRef(
  ({ onError = () => {}, onChange = () => {}, onExpired = () => {} }, ref) => {
    const handleError = (error) => {
      onError();
      console.log("ERROR", { ...error });
    };

    const handleExpired = (warning) => {
      onExpired();
      console.log("EXPIRED", { warning });
    };

    const SITE_KEY =
      process.env.REACT_APP_CAPTCHA_KEY ??
      "6LcTr_YcAAAAAKnsseyQVSnkgpQM5FnRKgkG52bK";

    return (
      <ReCAPTCHA
        ref={ref}
        sitekey={SITE_KEY}
        onChange={onChange}
        onErrored={handleError}
        onExpired={handleExpired}
      />
    );
  }
);

export default Captcha;
